import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsStagesProgress(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_STAGES_PROGRESS,
		ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS].GET_REPORTS_STAGES_PROGRESS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS].GET_REPORTS_STAGES_PROGRESS]: _getReportsStagesProgress,
}